import { localeHeaders } from '@repo/i18n/browser';
import { createTRPCClient, httpBatchLink, httpLink, splitLink } from '@trpc/client';
import SuperJSON from 'superjson';
import type {
  AppRouter,
  ReactQueryOptions,
  RouterInputs,
  RouterOutputs,
} from '../../../../packages/trpc/src/router';

declare global {
  interface Window {
    ENV?: Record<string, string | undefined>;
  }
}

export const trpc = createTRPCClient<AppRouter>({
  links: [
    splitLink({
      condition: (op) => op.context.skipBatch === true,
      true: httpLink({
        url: `${process.env.BUN_PUBLIC_API_URL}/api/trpc`,
        transformer: SuperJSON,
        fetch: (url, options) => {
          return fetch(url, {
            ...options,
            headers: { ...Object.fromEntries(new Headers(options?.headers)), ...localeHeaders() },
            credentials: 'include',
          });
        },
        headers: (opts) => {
          if (typeof opts.op.context.organizationId === 'string') {
            return {
              'x-organization-id': opts.op.context.organizationId,
            };
          }
          return {};
        },
      }),
      false: httpBatchLink({
        url: `${process.env.BUN_PUBLIC_API_URL}/api/trpc`,
        transformer: SuperJSON,
        fetch: (url, options) => {
          return fetch(url, {
            ...options,
            headers: { ...Object.fromEntries(new Headers(options?.headers)), ...localeHeaders() },
            credentials: 'include',
          });
        },
        headers: (opts) => {
          const operationWithOrganizationId = opts.opList.find(
            (op) => op.context.organizationId && typeof op.context.organizationId === 'string',
          );

          if (
            operationWithOrganizationId &&
            typeof operationWithOrganizationId.context.organizationId === 'string'
          ) {
            return {
              'x-organization-id': operationWithOrganizationId.context.organizationId,
            };
          }

          return {};
        },
      }),
    }),
  ],
});

export type { AppRouter, ReactQueryOptions, RouterInputs, RouterOutputs };
